module.exports = __webpack_public_path__ + "img/tips3list2img19120306.059f4f10.jpg";